"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useChartDataProviderProProps = void 0;
var _internals = require("@mui/x-charts/internals");
const useChartDataProviderProProps = props => {
  const {
    chartProviderProps,
    localeText,
    children
  } = (0, _internals.useChartDataProviderProps)(props);
  return {
    children,
    localeText,
    chartProviderProps
  };
};
exports.useChartDataProviderProProps = useChartDataProviderProProps;